/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SessionIntent } from './SessionIntent';
import {
    SessionIntentFromJSON,
    SessionIntentFromJSONTyped,
    SessionIntentToJSON,
    SessionIntentToJSONTyped,
} from './SessionIntent';

/**
 * 
 * @export
 * @interface SetRunIntentRequest
 */
export interface SetRunIntentRequest {
    /**
     * 
     */
    runId: string;
    /**
     * 
     */
    intent?: SessionIntent | null;
}



/**
 * Check if a given object implements the SetRunIntentRequest interface.
 */
export function instanceOfSetRunIntentRequest(value: object): value is SetRunIntentRequest {
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    return true;
}

export function SetRunIntentRequestFromJSON(json: any): SetRunIntentRequest {
    return SetRunIntentRequestFromJSONTyped(json, false);
}

export function SetRunIntentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetRunIntentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
        'intent': json['intent'] === undefined ? undefined : json['intent'] === null ? null : SessionIntentFromJSON(json['intent']),
    };
}

export function SetRunIntentRequestToJSON(json: any): SetRunIntentRequest {
    return SetRunIntentRequestToJSONTyped(json, false);
}

export function SetRunIntentRequestToJSONTyped(value?: SetRunIntentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'run_id': value['runId'],
        'intent': SessionIntentToJSON(value['intent']),
    };
}

